var SvcsScreenOtherIfeMovies = (function ($) {

    SvcsScreenOtherIfeMovies = function (options) {
        var that = this;

        that.class = {
            is_active: 'is-active',
            
            svc_action: 'js-svc-action',
            svc_action_text_desktop: 'js-svc-action-text-desktop',
            svc_action_text_mobile: 'js-svc-action-text-mobile',
            svc_action_confirm: 'js-svc-action-confirm',
            svc_action_cancel: 'js-svc-action-cancel',
            svc_title: 'js-svc-title',
            svc_sub_title: 'js-svc-sub-title', 
            svc_content: 'js-svc-content',
            svc_total: 'js-svcs-ife-movies-total-value',
            
            svc_card_wrapper: 'js-svc-card-wrapper',
        };

        that.selectors = {
            select_segment_passengers: UISelectSegmentPassengers.prototype.selectors.select_segment_passengers,
        };

        that.$wrapper = options['$wrapper'];
        
        that.analytics_dataset = options.analytics_dataset || null;

        if (that.$wrapper && that.$wrapper.length) {
            // DOM

            // CONST
            that.items_unpaid_initial_count = that.__countItemsQuantity(
                [].concat(
                    options['items_unpaid'] || [],
                    options['items_default'] || []
                )
            );
            
            that.order_currency = options['order_currency'] || '';
            that.need_force_select = options['need_force_select'] || false;

            // DYNAMIC VARS
            that.items_unpaid = [];
            that.items_paid = options['items_paid'] || [];
            that.total = options['total'] || 0;

            // HANDLERS
            that.onPassengerSelected = (options['onPassengerSelected'] || function () {
            });
            that.onPassengerReset = (options['onPassengerReset'] || function () {
            });
            that.onButtonConfirmClick = (options['onButtonConfirmClick'] || function () {
            });
            that.onButtonCancelClick = (options['onButtonCancelClick'] || function () {
            });

            // COMPONENTS
            that.select_segment_passengers = [];

            // INIT
            that.init(options);
        }
    }

    SvcsScreenOtherIfeMovies.prototype.init = function (options) {
        var that = this,
            items_unpaid = options['items_unpaid'] || [];
        
        //
        that.svcActionHandler();
        //
        that.initSelectSegmentPassengers(items_unpaid);
        //
        // SELECT SVC ON TOGGLE CARD BUTTON CLICK (https://tracker.flysa.ru/browse/SMA-2290)
        if (that.need_force_select) {
            that.__forceSelect();
        }
        //
        // set Added state to submit button if there are any paid or unpaid items
        if (
            (items_unpaid.length && items_unpaid[0]['item_quantity'] > 0) ||
            that.items_paid.length
        ) {
            that.__setActionContinue();
        }
    };
    
    // SELECT SVC ON TOGGLE CARD BUTTON CLICK (https://tracker.flysa.ru/browse/SMA-2290)
    SvcsScreenOtherIfeMovies.prototype.__forceSelect = function () {
        var that = this;

        // if svc is already selected, or force select was already performed on this svc
        if (that.items_unpaid.some(selection => (
                parseInt(selection.item_quantity, 10) > 0
            ))
        ) {
            return;
        }

        // if svc is already paid
        if (that.items_paid && that.items_paid.length) {
            return;
        }

        that.select_segment_passengers.forEach(function (select_segment_passengers) {
            var $passengers = select_segment_passengers.getSegmentPassengersAll();

            $passengers.each(function () {
                var $passenger = $(this),
                    svc_passenger_id = select_segment_passengers.getPassengerId($passenger),
                    svc_id = select_segment_passengers.getPassengerSelectionId($passenger),
                    svc_price = select_segment_passengers.getPassengerSelectionPrice($passenger);

                if (svc_passenger_id && svc_id) {
                    select_segment_passengers.select(
                        svc_passenger_id,
                        svc_id,
                        svc_price,
                        {
                            force_select: true
                        },
                        1,
                        1
                    );
                }
            });
        });
    };
    
    SvcsScreenOtherIfeMovies.prototype.svcActionHandler = function () {
        var that = this,
            $action = that.$wrapper.find('.' + that.class.svc_action);

        $action.on('click', function (event) {
            var $this = $(this);

            if ($this.hasClass(that.class.svc_action_confirm)) {
                that.onButtonConfirmClick(that.items_unpaid, that, event);
            } else if ($this.hasClass(that.class.svc_action_cancel)) {
                that.onButtonCancelClick(that.items_unpaid, that, event);
            }
        });
    };

    SvcsScreenOtherIfeMovies.prototype.initSelectSegmentPassengers = function (selected_items_unpaid = []) {
        var that = this,
            $select_segment_passengers = that.$wrapper.find(that.selectors.select_segment_passengers),
            options;

        options = {
            $container: that.$wrapper,
            collapse_on_select_all: false,
            items_unpaid: selected_items_unpaid,
            items_paid: that.items_paid,
            onPassengerSelected: function (data, component) {
                that.__onSelect(data);
            },
            onPassengerReset: function (data, call_callback_after, component) {
                that.__onReset(data);
            }
        };

        $select_segment_passengers.each(function () {
            that.select_segment_passengers.push(
                new UISelectSegmentPassengers(Object.assign({}, options, {$wrapper: $(this)}))
            );
        });
    };

    SvcsScreenOtherIfeMovies.prototype.clearSelectSegmentPassengers = function () {
        var that = this;
        that.select_segment_passengers = [];
    };

    SvcsScreenOtherIfeMovies.prototype.__onSelect = function (data) {
        var that = this,
            quantity_all;

        if (Array.isArray(data)) {
            data.forEach(function (data_item) {
                that.__saveSvc(data_item);
            });
        } else {
            that.__saveSvc(data);
        }

        that.__displayTotal();

        quantity_all = that.__getQuantityAll(); // get all svcs quantity after collection update
        // Update submit button state
        // if quantity was set to initial value - set initial state
        if (quantity_all === that.items_unpaid_initial_count) {
            that.__setActionInitial();
        }
        // if current quantity is lesser than initial one - set Confirm state
        else if (quantity_all < that.items_unpaid_initial_count) {
            that.__setActionContinue();
        }
        // if current quantity is greater than initial one - set Add state
        else {
            that.__setActionAdded();
        }
    };

    SvcsScreenOtherIfeMovies.prototype.__onReset = function (data) {
        var that = this,
            quantity_all;

        if (!that.items_unpaid.length) {
            return;
        }

        if (Array.isArray(data)) {
            data.forEach(function (data_item) {
                that.__resetSvc(data_item);
            });
        } else {
            that.__resetSvc(data);
        }

        that.__displayTotal();

        quantity_all = that.__getQuantityAll(); // get all svcs quantity after collection update
        if (quantity_all === 0) {
            if (that.items_paid && that.items_paid.length) {
                that.__setActionContinue();
            } else {
                that.__setActionEmpty();
            }
        }
        // if quantity was dropped to initial value - set initial state
        else if (quantity_all === that.items_unpaid_initial_count) {
            that.__setActionInitial();
        }
        // if quantity was dropped, but current quantity is still greater than initial one - set Add state
        else if (quantity_all > that.items_unpaid_initial_count) {
            that.__setActionAdded();
        }
        // if quantity was dropped, and current quantity is lesser than initial one - set Confirm state
        else {
            that.__setActionContinue();
        }
    };

    SvcsScreenOtherIfeMovies.prototype.__saveSvc = function (data) {
        var that = this,
            item_changed_index = that.items_unpaid.length ? that.items_unpaid.findIndex(selection => (
                    selection.segment_id.toString()   === data.segment_id.toString() &&
                    selection.passenger_id.toString() === data.passenger_id.toString() &&
                    selection.item_id.toString()      === data.item_id.toString()
                )
            ) : -1,
            quantity = data.item_quantity ? parseInt(data.item_quantity, 10) : 0,
            quantity_diff = data.item_quantity_diff ? parseInt(data.item_quantity_diff, 10) : 0,
            price = parseFloat(data.item_price);

        // if item is already saved, update quantity
        if (item_changed_index !== -1) {
            that.items_unpaid[item_changed_index]['item_quantity'] = quantity;
            that.items_unpaid[item_changed_index]['item_quantity_diff'] = quantity_diff;

            // SELECT SVC ON TOGGLE CARD BUTTON CLICK (https://tracker.flysa.ru/browse/SMA-2290)
            if (data.hasOwnProperty('force_select')) {
                that.items_unpaid[item_changed_index]['force_select'] = data.force_select;
            }
        } else {
            that.items_unpaid.push(data);
        }

        that.__changeTotal(price, quantity_diff);

        that.onPassengerSelected(data, that);
    };

    SvcsScreenOtherIfeMovies.prototype.__resetSvc = function (data) {
        var that = this,
            item_changed_index = that.items_unpaid.findIndex(selection => (
                    selection.segment_id.toString()   === data.segment_id.toString() &&
                    selection.passenger_id.toString() === data.passenger_id.toString() &&
                    selection.item_id.toString()      === data.item_id.toString()
                )
            ),
            quantity = data.item_quantity ? parseInt(data.item_quantity, 10) : 0,
            quantity_diff = data.item_quantity_diff ? parseInt(data.item_quantity_diff, 10) : 0,
            price = parseFloat(data.item_price);

        // remove item
        if (item_changed_index === -1) {
            $.sa.log('Error reset svc: not exists in set of selections');
            return;
        }

        that.items_unpaid[item_changed_index]['item_quantity'] = quantity;
        that.items_unpaid[item_changed_index]['item_quantity_diff'] = quantity_diff;

        that.__changeTotal(price, quantity_diff);

        that.onPassengerReset(data, that);
    };

    SvcsScreenOtherIfeMovies.prototype.__setActionInitial = function () {
        var that = this;
        // if there were any unpaid items on init - set Confirm state
        if (that.items_unpaid_initial_count > 0) {
            that.__setActionContinue();
        }
        // if there were no unpaid items, but there are any paid items - set Continue state
        else if (that.items_paid && that.items_paid.length) {
            that.__setActionContinue();
        }
        // if there were no unpaid items on init, and no paid items - set Empty state
        else {
            that.__setActionEmpty();
        }
    };

    SvcsScreenOtherIfeMovies.prototype.__setActionEmpty = function () {
        var that = this;
        that.__setActionTextFor('empty');
        that.__setActionTypeCancel();
    };

    SvcsScreenOtherIfeMovies.prototype.__setActionAdded = function () {
        var that = this;
        that.__setActionTextFor('added', (!$.sa.is_desktop() ? ' ' + that.__formatTotalPrice() : ''));
        that.__setActionTypeConfirm();
    };

    SvcsScreenOtherIfeMovies.prototype.__setActionContinue = function () {
        var that = this;
        that.__setActionTextFor('continue');
        that.__setActionTypeConfirm();
    };

    SvcsScreenOtherIfeMovies.prototype.__setActionTextFor = function (state, text_append = '') {
        var that = this,
            is_desktop = $.sa.is_desktop(),
            $action = that.$wrapper.find('.' + that.class.svc_action),
            $action_text = is_desktop
                ? $action.find('.' + that.class.svc_action_text_desktop)
                : $action.find('.' + that.class.svc_action_text_mobile),
            text = '' + $action_text.data(state + '-text') + text_append;
        $action_text.text(text);
    };

    SvcsScreenOtherIfeMovies.prototype.__setActionTypeCancel = function () {
        var that = this;
        that.$wrapper.find('.' + that.class.svc_action)
            .addClass(that.class.svc_action_cancel)
            .removeClass(that.class.svc_action_confirm);
    };

    SvcsScreenOtherIfeMovies.prototype.__setActionTypeConfirm = function () {
        var that = this;
        that.$wrapper.find('.' + that.class.svc_action)
            .addClass(that.class.svc_action_confirm)
            .removeClass(that.class.svc_action_cancel);
    };

    SvcsScreenOtherIfeMovies.prototype.__changeTotal = function (value, multiplier = 1) {
        value = parseFloat(value);
        multiplier = parseFloat(multiplier);

        var that = this,
            amount = value * multiplier;

        if (amount < 0 && that.total < Math.abs(amount)) {
            $.sa.log('Error count total price');
        } else {
            that.total += amount;
        }
    };

    SvcsScreenOtherIfeMovies.prototype.__formatTotalPrice = function () {
        var that = this;
        return $.sa.format.price(that.total, that.order_currency);
    };

    SvcsScreenOtherIfeMovies.prototype.__displayTotal = function () {
        var that = this;

        if (!that.order_currency) {
            return;
        }

        var $total_amount = that.$wrapper.find('.' + that.class.svc_total),
            total_amount_text = that.__formatTotalPrice();

        $total_amount.text(total_amount_text);
    };

    SvcsScreenOtherIfeMovies.prototype.__getQuantityAll = function () {
        var that = this;
        return that.__countItemsQuantity(that.items_unpaid);
    };

    SvcsScreenOtherIfeMovies.prototype.__countItemsQuantity = function (items) {
        var quantity = 0;
        items.forEach(function (selection) {
            quantity += (selection.hasOwnProperty('item_quantity') ? parseInt(selection.item_quantity, 10) : 0);
        });
        return quantity;
    };

    return SvcsScreenOtherIfeMovies;
})($);